import TacheView from './TacheView';
import React, {useState, useMemo} from 'react';
import {deleteTache} from '../../../services/MadricService';
import './Tache.css';
import swal from 'sweetalert';

/**
 * Permet de modifier ou d'ajouter une tâche
 * @param {*} props props
 * @return {JSX}
 */
function Tache(props) {
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 18;

  const filteredTaches = useMemo(() => {
    return props.taches
        .filter((tache) =>
          searchInput
              .toLowerCase()
              .split(' ')
              .every(
                  (term) =>
                    tache.name.toLowerCase().includes(term),
              ),
        );
  }, [searchInput, props.taches]);


  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, filteredTaches.length);

  const displayedTaches = filteredTaches.slice(startIndex, endIndex);

  /**
  * Permet de gérer la searchBar
  * @param {*} e event
  */
  function handleSearchInput(e) {
    setSearchInput(e.target.value);
    setCurrentPage(1);
  }

  /**
   * Permet de changer de pages
   * @param {*} newPage L page à afficher
   */
  function handlePageChange(newPage) {
    setCurrentPage(newPage);
  }

  const isButtonDisabled = (symbol) => {
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === Math.ceil(filteredTaches.length / pageSize) || filteredTaches.length === 0;
    return symbol.props.icon.iconName === 'angles-left' || symbol.props.icon.iconName === 'angle-left' ? isFirstPage : isLastPage;
  };

  /**
   * Permet de supprimer une tache
   * @param {*} tache la tâche à supprimer
   */
  async function supprimer(tache) {
    swal({
      title: 'Êtes-vous sûre de vouloir supprimer ' + tache.name,
      text: 'Une fois supprimer vous n\'y aurai plus accès',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });
            props.setTaches((prevItems) => prevItems.filter((item) => item.id !== tache.id));
            await deleteTache(tache.id);
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <div>
      <TacheView
        searchInput={searchInput}
        handleSearchInput={handleSearchInput}
        handlePageChange={handlePageChange}
        isButtonDisabled={isButtonDisabled}
        displayedTaches={displayedTaches}
        supprimer={supprimer}
        taches={props.taches}
        setTaches={props.setTaches}
        pageSize={pageSize}
        currentPage={currentPage} />
    </div>
  );
}

export default Tache;
